import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";

export class AccessTokenStore {
  private static _accessToken: string | undefined;
  private static _resolvePromise: ((token: string) => void) | null = null;
  private static _accessTokenPromise: Promise<string>;

  static {
    this._accessTokenPromise = new Promise((resolve) => {
      this._resolvePromise = resolve;
    });
  }

  static async getAccessToken(): Promise<string> {
    return this._accessTokenPromise;
  }

  static set accessToken(token: string) {
    this._accessToken = token;
    if (this._resolvePromise) {
      this._resolvePromise(token);
      this._resolvePromise = null;
    }
    this._accessTokenPromise = Promise.resolve(token);
  }

  static get accessToken(): string | undefined {
    return this._accessToken;
  }
}

export function useSession(): { accessToken: string | undefined } {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  const [accessToken, setAccessToken] = useState<string | undefined>(undefined);

  useEffect(() => {
    async function load() {
      try {
        const token = await getAccessTokenSilently();
        AccessTokenStore.accessToken = token;
        setAccessToken(token);
      } catch (error) {
        console.error("Failed to get access token", error);
      }
    }

    if (isAuthenticated) {
      load();
    }
  }, [isAuthenticated, getAccessTokenSilently]);

  return { accessToken };
}
